import { AnniversaryData } from '../types/types';
import photo_10_03_24 from '../assets/photos/10-3-24.jpg';
import photo_9_25_24 from '../assets/photos/9-25-24.jpg';
import photo_10_28_24 from '../assets/photos/10-28-24.jpg';
import photo_4_2_24 from '../assets/photos/4-2-24.JPG';
import photo_4_22_24 from '../assets/photos/4-22-24.JPG';
import photo_5_20_24 from '../assets/photos/5-20-24.JPG';
import photo_5_17_24 from '../assets/photos/5-17-24.JPG';
import photo_5_18_24 from '../assets/photos/5-18-24.JPG';
import photo_5_4_24 from '../assets/photos/5-4-24.JPG';
import photo_5_31_24 from '../assets/photos/5-31-24.JPG';
import photo_6_2_24 from '../assets/photos/6-2-24.JPG';
import photo_6_3_24 from '../assets/photos/6-3-24.JPG';
import photo_6_8_24 from '../assets/photos/6-8-24.JPG';
import photo_6_8_24_2 from '../assets/photos/6-8-24-2.JPG';
import photo_6_19_24 from '../assets/photos/6-19-24.JPG';
import photo_6_29_24 from '../assets/photos/6-29-24.JPG';
import photo_7_14_24 from '../assets/photos/7-14-24.JPG';
import photo_7_14_24_2 from '../assets/photos/7-14-24-2.JPG';
import photo_7_30_24 from '../assets/photos/7-30-24.JPG';
import photo_8_3_24 from '../assets/photos/8-3-24.JPG';
import photo_9_1_24 from '../assets/photos/9-1-24.JPG';
import photo_9_2_24 from '../assets/photos/9-2-24.JPG';
import photo_9_29_24 from '../assets/photos/9-29-24.JPG';
import photo_10_13_24 from '../assets/photos/10-13-24.JPG';
import photo_10_31_24 from '../assets/photos/10-31-24.JPG';
import photo_11_17_24 from '../assets/photos/11-17-24.JPG';
import photo_1_1_25 from '../assets/photos/1-1-25.JPG';
import photo_1_18_25 from '../assets/photos/1-18-25.JPG';
import photo_2_8_25 from '../assets/photos/2-8-25.JPG';
import photo_2_9_25 from '../assets/photos/2-9-25.JPG';
import photo_2_14_25 from '../assets/photos/2-14-25.JPG';
import photo_2_18_2 from '../assets/photos/2-18-2.JPG';
import photo_2_24_25 from '../assets/photos/2-24-25.JPG';
import photo_2_27_25 from '../assets/photos/2-27-25.JPG';
import photo_3_20_25 from '../assets/photos/3-20-25.JPG';
import photo_4_6_25 from '../assets/photos/4-6-25.JPG';
import photo_3_16_25 from '../assets/photos/3-16-25.png';
import photo_5_24_25 from '../assets/photos/5-24-25.png';
import photo_6_7_25 from '../assets/photos/6-7-25.png';
import photocard1 from '../assets/photocards/freaknik-couple.JPG';
import photocard2 from '../assets/photocards/artsy-couple.png';
import photocard3 from '../assets/photocards/birthday-love.JPG';
import photocard4 from '../assets/photocards/official-day.JPG';
import photocard5 from '../assets/photocards/birthday-shenans.png';
import photocard6 from '../assets/photocards/last-christmas.jpeg';
// import photocard5 from '../assets/photocards/photocard-5.jpg';
// import photocard6 from '../assets/photocards/photocard-6.jpg';

// Sample data for the anniversary memory book
// You'll replace these with your actual data
const anniversaryData: AnniversaryData = {
  metrics: [
    {
      id: 'days',
      value: '730',
      label: 'Days Together'
    },
    {
      id: 'dates',
      value: '104',
      label: 'Dates'
    },
    {
      id: 'restaurants',
      value: '87',
      label: 'Restaurants Visited'
    },
    {
      id: 'trips',
      value: '12',
      label: 'Trips Taken'
    },
    {
      id: 'movies',
      value: '53',
      label: 'Movies Watched'
    },
    {
      id: 'hoodies',
      value: '8',
      label: 'Hoodies Stolen'
    }
  ],
  photos: [
    {
      id: 'photo1',
      path: photo_10_03_24,
      caption: '1st Thursday in SF',
      date: '2024-10-03'
    },
    {
      id: 'photo2',
      path: photo_9_25_24,
      caption: 'Last A\'s Game',
      date: '2024-09-25'
    },
    {
      id: 'photo3',
      path: photo_10_28_24,
      caption: 'Ax throwing date',
      date: '2024-10-28'
    },
    {
      id: 'photo4',
      path: photo_4_2_24,
      caption: 'being cute',
      date: '2024-04-02',
    },
    {
      id: 'photo5',
      path: photo_4_22_24,
      caption: 'LOVE in philly',
      date: '2024-04-22'
    },
    {
      id: 'photo6',
      path: photo_5_4_24,
      caption: 'being cute again',
      date: '2024-05-04'
    },
    {
      id: 'photo7',
      path: photo_5_17_24,
      caption: 'Vegas play',
      date: '2024-05-17'
    },
    {
      id: 'photo8',
      path: photo_5_18_24,
      caption: '1st Aces game!',
      date: '2024-05-18'
    },
    {
      id: 'photo9',
      path: photo_5_20_24,
      caption: 'Magic mountains <3',
      date: '2024-05-20'
    },
    {
      id: 'photo10',
      path: photo_5_31_24,
      caption: 'En route to philly',
      date: '2024-05-31'
    },
    {
      id: 'photo11',
      path: photo_6_2_24,
      caption: 'Roots picnic tings',
      date: '2024-06-02'
    },
    {
      id: 'photo12',
      path: photo_6_3_24,
      caption: 'Hanging out at spruce st harbor park in philly',
      date: '2024-06-03'
    },
    {
      id: 'photo13',
      path: photo_6_8_24,
      caption: 'HADESTOWN!',
      date: '2024-06-08'
    },
    {
      id: 'photo14',
      path: photo_6_8_24_2,
      caption: 'Brooklyn museum party',
      date: '2024-06-08'
    },
    {
      id: 'photo15',
      path: photo_6_19_24,
      caption: 'Anniversary dinner rain check',
      date: '2024-06-19'
    },
    {
      id: 'photo16',
      path: photo_6_29_24,
      caption: 'Anisa\'s high schoolreunion',
      date: '2024-06-29'
    },
    {
      id: 'photo17',
      path: photo_7_14_24,
      caption: 'YEEHAWWWWW RODEOOO',
      date: '2024-07-14'
    },
    {
      id: 'photo18',
      path: photo_7_14_24_2,
      caption: 'we got our keys!!',
      date: '2024-07-14'
    },
    {
      id: 'photo19',
      path: photo_7_30_24,
      caption: 'baby\'s birthday',
      date: '2024-07-30'
    },
    {
      id: 'photo20',
      path: photo_8_3_24,
      caption: 'Love in santa cruz',
      date: '2024-08-03'
    },
    {
      id: 'photo21',
      path: photo_9_1_24,
      caption: 'Twisters in 4DX!',
      date: '2024-09-01'
    },
    {
      id: 'photo22',
      path: photo_9_2_24,
      caption: 'Twisters in 4DX! AGAIN!',
      date: '2024-09-02'
    },
    {
      id: 'photo23',
      path: photo_9_29_24,
      caption: 'portola chillin',
      date: '2024-09-29'
    },
    {
      id: 'photo24',
      path: photo_10_13_24,
      caption: 'day partyin',
      date: '2024-10-13'
    },
    {
      id: 'photo25',
      path: photo_10_31_24,
      caption: 'fifth element halloween <3',
      date: '2024-10-31'
    },
    {
      id: 'photo26',
      path: photo_11_17_24,
      caption: 'hot pot!!',
      date: '2024-11-17'
    },
    {
      id: 'photo27',
      path: photo_1_1_25,
      caption: 'new year new us in LA',
      date: '2025-01-01'
    },
    {
      id: 'photo28',
      path: photo_1_18_25,
      caption: 'Houston in the scary bathroom',
      date: '2025-01-18'
    },
    {
      id: 'photo29',
      path: photo_2_8_25,
      caption: 'MD looking sexy',
      date: '2025-02-08'
    },
    {
      id: 'photo30',
      path: photo_2_9_25,
      caption: 'MD trip mirror selfie',
      date: '2025-02-09'
    },
    {
      id: 'photo31',
      path: photo_2_14_25,
      caption: 'my birthday dinner',
      date: '2025-02-14'
    },
    {
      id: 'photo32',
      path: photo_2_18_2,
      caption: 'somewhere in houston',
      date: '2025-02-18'
    },
    {
      id: 'photo33',
      path: photo_2_24_25,
      caption: 'inconspicuous couple',
      date: '2025-02-24'
    },
    {
      id: 'photo34',
      path: photo_2_27_25,
      caption: 'another bathroom selfie',
      date: '2025-02-27'
    },
    {
      id: 'photo35',
      path: photo_3_20_25,
      caption: 'yet another bathroom selfie',
      date: '2025-03-20'
    },
    {
      id: 'photo36',
      path: photo_4_6_25,
      caption: 'baby\'s black belt ceremony',
      date: '2025-04-06'
    },
    {
      id: 'photo37',
      path: photo_3_16_25,
      caption: 'another night @ midway',
      date: '2025-03-16'
    },
    {
      id: 'photo38',
      path: photo_5_24_25,
      caption: 'trip to long beach',
      date: '2025-05-24'
    },
    {
      id: 'photo39',
      path: photo_6_7_25,
      caption: 'kissing the prettiest girl in the club',
      date: '2025-06-07'
    }
  ],
  playlist: {
    id: '4t9RovL23Qn2uXnVwZFeHC',
    title: 'zanisa two years',
    description: 'love runs deep'
  },
  photocards: [
    {
      id: 'card1',
      frontImage: photocard1,
      title: 'FREAKNIK',
      koreanTitle: '괴짜 생일',
      subtitle: 'FREAKNIK BIRTHDAY',
      description: 'In true freaknik style, with money raining around us. Geeking.'
    },
    {
      id: 'card2',
      frontImage: photocard2,
      title: 'Day Party Daze',
      koreanTitle: '데이 파티 데이즈',
      subtitle: 'Another day, another party',
      description: 'Nothing is better than a day party with you'
    },
    {
      id: 'card3',
      frontImage: photocard3,
      title: 'Birthday Shenanigans',
      koreanTitle: '생일 잔치',
      subtitle: 'Birthday Shenanigans',
      description: 'you are so beautiful'
    },
    {
      id: 'card4',
      frontImage: photocard5,
      title: 'Best Dance of my Life',
      koreanTitle: '내 인생 최고의 댄스',
      subtitle: 'Best Dance of my Life',
      description: 'still drooling'
    },
    {
      id: 'card5',
      frontImage: photocard4,
      title: 'Official Day',
      koreanTitle: '공식적인 날',
      subtitle: 'The official Day!!',
      description: 'thank you endlessly for saying yes'
    },
    {
      id: 'card6',
      frontImage: photocard6,
      title: 'Last Christmas',
      koreanTitle: '마지막 크리스마스',
      subtitle: 'Last Christmas',
      description: 'our special family'
    }
  ]
};

export default anniversaryData; 